import React from "react";
import PropTypes from 'prop-types';

export default class TextBlock extends React.PureComponent {
    render() {
        let { text, children } = this.props;

        return (
            <div className={'text-block'}>
                {text}{children}
            </div>
        );
    }
}

TextBlock.propTypes = {
    text: PropTypes.string,
    children: PropTypes.node,
};
